


















import {
  computed,
  defineComponent,
  PropType,
  ref,
} from '@nuxtjs/composition-api'
import { v4 as uuidv4 } from 'uuid'
type Options = {
  label: string
  value: any
}
export default defineComponent({
  name: 'InputRadio',
  props: {
    value: {
      require: true,
    },
    options: {
      type: Array as PropType<Options[]>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const uuid = uuidv4()
    const val = computed({
      get: () => props.value,
      set: (value) => {
        emit('change', value)
      },
    })
    return {
      uuid,
      val,
    }
  },
})
